import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetTripTypesQuery } from "../../redux/Service/api";
import fallBackImage from "../../assets/Bookings1.png";

// Define TripType interface if needed
interface TripType {
  TripTypeID: number;
  TripTypeName: string;
  TripTypeImageName: string; // Add this if your API returns image URLs for trip types
}

const ServicesSection = () => {
  const navigate = useNavigate();

  // Fetch trip types data
  const {
    data: tripTypesData,
    isError: isTripTypesError,
    isLoading: isTripTypesLoading,
  } = useGetTripTypesQuery(undefined);

  const tripTypes: TripType[] = tripTypesData?.ResponseObject ?? [];

  // Navigate to trip details or appropriate page
  const handleNavigate = (id: number) => {
    navigate(`/Trip/${id}`);
  };

  if (isTripTypesLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-500">Loading services...</p>
      </div>
    );
  }

  if (isTripTypesError) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-red-500">
          Failed to load services. Please try again.
        </p>
      </div>
    );
  }

  if (tripTypes.length === 0) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-500">No services available at the moment.</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-10">
      {/* Section Title */}
      <h2 className="text-center text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-8">
        أنواع خدماتنا
      </h2>

      {/* Services Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5 sm:gap-7 lg:gap-8 justify-center">
        {tripTypes.map((tripType) => (
          <div
            key={tripType.TripTypeID}
            className="grid gap-3 p-3 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
          >
            <img
              src={
                tripType.TripTypeImageName
                  ? "https://api.prosofteg.com:5001/" +
                    tripType.TripTypeImageName
                  : fallBackImage
              }
              className="w-full object-cover h-48 rounded-md"
              alt={tripType.TripTypeName}
            />
            <div className="px-5 py-2.5 rounded-md text-blue-900 text-sm tracking-wider font-bold">
              {tripType.TripTypeName}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesSection;
